
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.992 4.371A3 3 0 0110.925 2h2.15a3 3 0 012.933 2.371l.485 2.26a7.006 7.006 0 012.222 3.384A1.5 1.5 0 0120 11.5v1a1.5 1.5 0 01-1.285 1.485 7.006 7.006 0 01-2.222 3.383l-.485 2.26A3 3 0 0113.075 22h-2.15a3 3 0 01-2.933-2.371l-.484-2.26A6.985 6.985 0 015 12c0-2.156.975-4.084 2.508-5.369l.484-2.26zM17 12a5 5 0 10-10 0 5 5 0 0010 0z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 8a1 1 0 011 1v2.586l1.207 1.207a1 1 0 01-1.414 1.414l-1.354-1.353A1.5 1.5 0 0111 11.793V9a1 1 0 011-1z"}})])
          )
        }
      }
    